module.exports = __webpack_public_path__ + "img/typeform_plugin.b6b08c60.png";